import React, { useEffect, useState } from 'react';
import Page, { PageHeader, PageTitle, Container } from 'components/Page';
import { Formik, Field, Form } from 'formik';
import BaseAlert from 'packages/ui/Alert';
import Button from 'packages/ui/Button';
import { api } from 'app';
import { FormControl, FormGroup, Label } from 'components/form/Formik';
import { PromoteType } from '../promote.enum';
import { useHistory } from 'react-router-dom';

function EvandPromotPage({ match: { params } }) {
  const { type } = params;
  const routerHistory = useHistory();
  const id = new URLSearchParams(window.location.search).get('id');
  const [loading, setLoading] = useState(true);
  const [submittingMsg, setSubmittingMsg] = useState('');
  const [initialValues, setInitialValues] = useState({
    title: '',
    description: '',
    cover_image: '',
    link: '',
    call_action_text: '',
    type: '',
    is_active: false,
    text_color: '',
    call_action_text_color: '',
    call_action_color: ''
  });

  useEffect(() => {
    if (type === 'new') {
      setLoading(false);
      return;
    }
    api
      .get(`/evand-promot/${type}?id=${id}`)
      .then(res => {
        const data = res.body.data;
        if (data) {
          setInitialValues({
            title: data.title || '',
            description: data.description || '',
            cover_image: data.cover_image || '',
            link: data.link || '',
            call_action_text: data.call_action_text || '',
            type: data.type || 'helloBar',
            is_active: data.is_active,
            text_color: data.text_color || '',
            call_action_text_color: data.call_action_text_color || '',
            call_action_color: data.call_action_color || ''
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, [type]);

  return (
    <Page>
      <PageHeader>
        <PageTitle>تبلیغ ایوند</PageTitle>
      </PageHeader>
      <Container>
        {!loading && (
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values, actions) => {
              actions.setSubmitting(true);
              if (type === 'new') {
                values.is_active = values.is_active ? 1 : 0;
                api
                  .post(`/evand-promot`, { ...values })
                  .then(() => {
                    setSubmittingMsg('تبلیغ با موفقیت ایجاد شد.');
                    setTimeout(() => {
                      routerHistory.push('/evand-promot');
                    }, 1000);
                  })
                  .catch(err => {
                    const firstError =
                      err && err.errors ? Object.values(err.errors)[0][0] : 'خطا در ارسال درخواست';
                    setSubmittingMsg(firstError);
                  })
                  .finally(() => actions.setSubmitting(false));
              } else {
                api
                  .put(`/evand-promot/${id}`, { ...values })
                  .then(() => {
                    setSubmittingMsg('تبلیغ با موفقیت ویرایش شد.');
                    setTimeout(() => {
                      routerHistory.push('/evand-promot');
                    }, 1000);
                  })
                  .catch(err => {
                    const firstError =
                      err && err.errors ? Object.values(err.errors)[0][0] : 'خطا در ارسال درخواست';
                    setSubmittingMsg(firstError);
                  })
                  .finally(() => actions.setSubmitting(false));
              }
            }}
          >
            {() => (
              <Form>
                <FormGroup>
                  <FormControl>
                    <Label htmlFor="title">عنوان</Label>
                    <Field id="title" name="title" type="text" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="description">توضیحات</Label>
                    <Field id="description" name="description" type="text" />
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormControl>
                    <Label htmlFor="cover_image">کاور</Label>
                    <Field id="cover_image" name="cover_image" type="text" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="link">لینک</Label>
                    <Field
                      id="link"
                      name="link"
                      placeholder="panel:events/{:slug}/webinar/record"
                      type="text"
                    />
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormControl>
                    <Label htmlFor="call_action_text">متن دکمه</Label>
                    <Field id="call_action_text" name="call_action_text" type="text" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="type">نوع</Label>
                    <Field id="type" name="type" as="select">
                      <option value="" />
                      {PromoteType.map(type => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </Field>
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormControl>
                    <Label htmlFor="is_active">فعال</Label>
                    <Field id="is_active" name="is_active" type="checkbox" />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="text_color">رنگ متن</Label>
                    <Field id="text_color" name="text_color" placeholder="#0000" type="text" />
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormControl>
                    <Label htmlFor="call_action_text_color">رنگ متن دکمه</Label>
                    <Field
                      id="call_action_text_color"
                      name="call_action_text_color"
                      placeholder="#ffff"
                      type="text"
                    />
                  </FormControl>
                  <FormControl>
                    <Label htmlFor="call_action_color">رنگ دکمه</Label>
                    <Field
                      id="call_action_color"
                      name="call_action_color"
                      placeholder="#ffff"
                      type="text"
                    />
                  </FormControl>
                </FormGroup>

                <Button type="submit">ذخیره</Button>

                {submittingMsg && (
                  <BaseAlert mood="info" title={submittingMsg}>
                    {submittingMsg}
                  </BaseAlert>
                )}
              </Form>
            )}
          </Formik>
        )}
      </Container>
    </Page>
  );
}

export default EvandPromotPage;
